var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgQuickRecharge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 237,
    height: 54,
    viewBox: "0 0 237 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7115",
    "data-name": "Group 7115",
    transform: "translate(-125 -1190)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2030",
    "data-name": "Rectangle 2030",
    width: 237,
    height: 54,
    rx: 27,
    transform: "translate(125 1190)",
    fill: "#f7bb06",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Recharge_quickly",
    "data-name": "Recharge quickly",
    transform: "translate(191 1225)",
    fill: "#212121",
    fontSize: 20,
    fontFamily: "JioType-Medium, JioType",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Recharge quickly")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(141 1196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7142",
    "data-name": "Path 7142",
    d: "M7.52-14.629a.909.909,0,0,0-.314-.355.8.8,0,0,0-.451-.137H1.066l1.75-8.367a.782.782,0,0,0-.068-.588.8.8,0,0,0-.451-.4.909.909,0,0,0-.6-.014.814.814,0,0,0-.465.369L-7.492-9.98a.734.734,0,0,0-.137.438.866.866,0,0,0,.109.438.866.866,0,0,0,.314.314.861.861,0,0,0,.451.123h5.633l-1.7,7.547a.889.889,0,0,0,.055.615.751.751,0,0,0,.438.4,1.08,1.08,0,0,0,.164.041A1,1,0,0,0-2-.055a.813.813,0,0,0,.41-.109,1.029,1.029,0,0,0,.328-.3L7.465-13.809a.547.547,0,0,0,.15-.369A.879.879,0,0,0,7.52-14.629Z",
    transform: "translate(160 1230.055)",
    fill: "#f7bb06",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7141",
    "data-name": "Path 7141",
    d: "M7.52-14.629a.909.909,0,0,0-.314-.355.8.8,0,0,0-.451-.137H1.066l1.75-8.367a.782.782,0,0,0-.068-.588.8.8,0,0,0-.451-.4.909.909,0,0,0-.6-.014.814.814,0,0,0-.465.369L-7.492-9.98a.734.734,0,0,0-.137.438.866.866,0,0,0,.109.438.866.866,0,0,0,.314.314.861.861,0,0,0,.451.123h5.633l-1.7,7.547a.889.889,0,0,0,.055.615.751.751,0,0,0,.438.4,1.08,1.08,0,0,0,.164.041A1,1,0,0,0-2-.055a.813.813,0,0,0,.41-.109,1.029,1.029,0,0,0,.328-.3L7.465-13.809a.547.547,0,0,0,.15-.369A.879.879,0,0,0,7.52-14.629Z",
    transform: "translate(162 1229)",
    fill: "#ffba00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickRecharge);
export default __webpack_public_path__ + "static/media/quick-recharge.06a4f6ae98cd38afd25a5e746c5ca755.svg";
export { ForwardRef as ReactComponent };